// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1FRqK","emails":"CreateEditClinics_emails__3jbyJ","emailTagLabel":"CreateEditClinics_emailTagLabel__I5onc"};